export default {"mobileHeader":"KCYR3","navBar":"yQfiN","burgerLogo":"-cDFS","burgerIcon":"tvV9N","iconWrapper":"vmcXm","ocIcon":"AnN7H","subMenu":"hsIWe"};